import '@fortawesome/fontawesome-free/css/all.min.css';
import { useState } from 'react';

function Webwasa() {
  const [activeTab, setActiveTab] = useState('methodology');

  return (
    <div>
      {/* -- Banner sec ---- */}
      <div className="page-banner-area">
        <h2>Services</h2>
        <div className="breadcrumbs-services">
          <ul>
            <li><a href="/">Home</a></li>
            <li>Web/WASA</li>
          </ul>
        </div>
      </div>
      {/* -- Banner sec ---- */}

      {/* ---- About service section ----- */}
      <div className="about-services-wrap">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12">

              {/* Headings */}
              <div className="heading-in mb-5">
                <h1>Web Application Security Testing/WAST</h1>
                <p>
                  <b className="sub-heading">Introduction</b><br/>
                  Web applications are the backbone of today’s digital economy — powering customer engagement, transactions, and mission-critical services. But with their importance comes increased risk: cybercriminals actively target web apps to steal data, disrupt operations, and damage reputations. <b>Web Application Security Testing (WAST)</b> proactively simulates real-world attacks to uncover and address vulnerabilities before they can be exploited. By securing your applications, you protect sensitive data, meet compliance requirements, and safeguard business continuity.
                </p>
              </div>

              {/* Why It Matters */}
              <div className="service-card-heading">
                <h1>Why It Matters</h1>
              </div>
              <div className="services-cards-wp">
                {[
                  { icon: "fa-arrows-down-to-people", title: "High-Value Targets", desc: "Web applications handle personal, financial, and business-critical data — making them prime attack vectors." },
                  { icon: "fa-database", title: "Evolving Threats", desc: "From SQL Injection to Cross-Site Scripting (XSS), new exploits emerge daily." },
                  { icon: "fa-shield-halved", title: "Compliance Pressures", desc: "Frameworks like PCI DSS, GDPR, HIPAA, and ISO 27001 demand robust security testing." },
                  { icon: "fa-table", title: "Trust & Reputation", desc: "Customers choose brands that prioritize security and protect their data." },
                  { icon: "fa-business-time", title: "Business Continuity", desc: "A single breach can cause downtime, financial loss, and lasting reputational harm." },
                ].map((item, i) => (
                  <div className="service-box" key={i}>
                    <div className="service-icon">
                      <i className={`fa-solid ${item.icon}`}></i>
                    </div>
                    <div className="service-card-content">
                      <h3>{item.title}</h3>
                      <p>{item.desc}</p>
                    </div>
                  </div>
                ))}
              </div>

              {/* Tabs */}
              <div className="tab-pill-sec-main">
                <div className="tab-inner-contain">
                  <ul className="nav nav-pills">
                    {[
                      { id: "methodology", label: "Methodology" },
                      { id: "keybenefits", label: "Key Benefits" },
                      { id: "deliverables", label: "Deliverables" },
                    ].map((tab) => (
                      <li className="nav-item" key={tab.id}>
                        <button
                          className={`nav-link${activeTab === tab.id ? " active" : ""}`}
                          onClick={() => setActiveTab(tab.id)}
                        >
                          {tab.label}
                        </button>
                      </li>
                    ))}
                  </ul>

                  <div className="tab-content">
                    {/* Methodology */}
                    <div className={`tab-pane fade${activeTab === "methodology" ? " show active" : ""}`} role="tabpanel">
                      <p>Our WAST process follows globally recognized standards such as OWASP Top 10, SANS 25, NIST and OSSTMM, combining automation with expert-driven manual testing:</p>
                      <ul>
                        <li><b>Information Gathering :-</b> Mapping the application’s technologies, architecture, and attack surface.</li>
                        <li><b>Threat Modeling :-</b> Identifying potential attacker paths and prioritizing critical risks.</li>
                        <li><b>Automated & Manual Testing :-</b> Detecting technical flaws and business logic weaknesses.</li>
                        <li><b>Exploitation & Validation :-</b> Safely confirming real-world exploitability without disruption.</li>
                        <li><b>Reporting :-</b> Delivering detailed insights with both technical and business context.</li>
                        <li><b>Re-Testing :-</b> Validating fixes to ensure vulnerabilities are fully remediated.</li>
                      </ul>
                    </div>

                    {/* Key Benefits */}
                    <div className={`tab-pane fade${activeTab === "keybenefits" ? " show active" : ""}`} role="tabpanel">
                      <ul>
                        <li>Detect vulnerabilities early, before attackers do.</li>
                        <li>Strengthen customer confidence with secure, reliable applications.</li>
                        <li>Meet compliance requirements and reduce regulatory risk.</li>
                        <li>Prevent downtime, data loss, and reputational damage.</li>
                        <li>Gain expert remediation guidance and validation testing.</li>
                        <li>Build a proactive, long-term security posture.</li>
                      </ul>
                    </div>

                    {/* Deliverables */}
                    <div className={`tab-pane fade${activeTab === "deliverables" ? " show active" : ""}`} role="tabpanel">
                      <p>At the conclusion of our WAST engagement, you will receive:</p>
                      <ul>
                        <li><b>Comprehensive Security Report :-</b> Technical findings with severity ratings and business impact.</li>
                        <li><b>Remediation Roadmap :-</b> Clear, prioritized steps your team can act on.</li>
                        <li><b>Executive Summary :-</b> A high-level overview for leadership and stakeholders.</li>
                        <li><b>Re-Testing & Validation :-</b> Assurance that fixes have been implemented effectively.</li>
                        <li><b>Ongoing Security Advisory :-</b> Continuous support to help you stay ahead of emerging threats.</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>

              {/* Our Approach */}
              <div className="our-approach-sec-main">
                <div className="container">
                  <h3>Our Approach</h3>
                  <p>
                    Choosing the right security partner can mean the difference between a generic report and a clear path to resilience.
                  </p>
                  <ul>
                    <li><b>Human Expertise Beyond Tools :-</b> Automated scanners catch common flaws, but our ethical hackers uncover the advanced risks that tools miss.</li>
                    <li><b>Business Logic Testing :-</b> Detect workflow vulnerabilities unique to your application — not just code-level issues.</li>
                    <li><b>Tailored Engagements :-</b> Every test is customized to your environment — web, mobile, or cloud.</li>
                    <li><b>Compliance Alignment :-</b> Testing structured to help you meet PCI DSS, GDPR, HIPAA, ISO 27001, and more.</li>
                    <li><b>Actionable Results :-</b> Reports are practical, prioritized, and executive-friendly — not just technical jargon.</li>
                    <li><b>Long-Term Partnership :-</b> From remediation support to continuous advisory, we’re committed to your ongoing security.</li>
                  </ul>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
      {/* ---- About service section ----- */}
    </div>
  );
}

export default Webwasa;
